export function renderKeywordTableView({
  getState,
  select,
  createElement,
  createPolicySelect,
  formatVolume,
  computeVirtualWindow,
  getPolicyMap,
  rowHeight,
  overscan,
  afterRender,
}) {
  const library = getState('keywordLibrary');
  if (!library) return;
  const filterCategory = getState('keywordFilterCategory') || 'all';
  const filterText = (getState('keywordFilterText') || '').toLowerCase();
  const policyMap = getPolicyMap();
  let keywords = [...library.keywords];
  if (filterCategory !== 'all' && library.categories?.[filterCategory]) {
    const categoryKeywords = new Set(library.categories[filterCategory].map((keyword) => keyword.keyword));
    keywords = keywords.filter((keyword) => categoryKeywords.has(keyword.keyword));
  }
  if (filterText) keywords = keywords.filter((keyword) => keyword.keyword.toLowerCase().includes(filterText));

  const tableHost = select('#keyword-library-table');
  const table = createElement('table', 'keyword-table');
  const headerRow = document.createElement('tr');
  const headers = [
    ['关键词', ''], ['搜索量', 'keyword-table-align-right'], ['CPC', 'keyword-table-align-right'],
    ['购买率', 'keyword-table-align-right'], ['频率', 'keyword-table-align-right'],
    ['评分', 'keyword-table-align-center'], ['来源', ''], ['准入策略', ''],
  ];
  headerRow.append(...headers.map(([label, className]) => createElement('th', className, label)));
  const thead = document.createElement('thead');
  const body = document.createElement('tbody');
  thead.append(headerRow);
  table.append(thead, body);
  tableHost.replaceChildren(table);

  const createSpacerRow = (height) => {
    const row = createElement('tr', 'keyword-virtual-spacer');
    row.setAttribute('aria-hidden', 'true');
    const cell = createElement('td', 'keyword-virtual-spacer-cell');
    cell.colSpan = 8;
    cell.height = Math.max(0, Math.round(height));
    row.append(cell);
    return row;
  };
  const createTableCell = (text, className = '') => createElement('td', className, text);
  const renderVisibleRows = () => {
    const virtualWindow = computeVirtualWindow({
      itemCount: keywords.length,
      scrollTop: tableHost.scrollTop,
      viewportHeight: tableHost.clientHeight,
      rowHeight,
      overscan,
    });
    const rows = keywords.slice(virtualWindow.start, virtualWindow.end).map((keyword) => {
      const scoreClass = keyword.relevanceScore >= 60
        ? 'keyword-table-score is-high'
        : keyword.relevanceScore >= 30
          ? 'keyword-table-score is-medium'
          : 'keyword-table-score is-low';
      const row = document.createElement('tr');
      const policyCell = document.createElement('td');
      policyCell.append(createPolicySelect(
        keyword.keyword,
        policyMap.get(keyword.keyword.toLowerCase())?.policy || 'can_use',
      ));
      row.append(
        createTableCell(keyword.keyword),
        createTableCell(formatVolume(keyword.searches30d), 'keyword-table-align-right'),
        createTableCell(keyword.cpc ? `$${keyword.cpc}` : '-', 'keyword-table-align-right'),
        createTableCell(keyword.purchaseRate ? `${(keyword.purchaseRate * 100).toFixed(1)}%` : '-', 'keyword-table-align-right'),
        createTableCell(keyword.frequency, 'keyword-table-align-right'),
        createTableCell(keyword.relevanceScore, `keyword-table-align-center ${scoreClass}`),
        createTableCell(keyword.source, 'keyword-table-source'),
        policyCell,
      );
      return row;
    });
    if (keywords.length) {
      body.replaceChildren(createSpacerRow(virtualWindow.topPadding), ...rows, createSpacerRow(virtualWindow.bottomPadding));
      return;
    }
    const row = document.createElement('tr');
    const cell = createElement('td', 'keyword-table-empty-cell', '暂无数据');
    cell.colSpan = 8;
    row.append(cell);
    body.replaceChildren(row);
  };
  if (tableHost._keywordVirtualScrollHandler) {
    tableHost.removeEventListener('scroll', tableHost._keywordVirtualScrollHandler);
  }
  tableHost._keywordVirtualScrollHandler = renderVisibleRows;
  tableHost.addEventListener('scroll', renderVisibleRows, { passive: true });
  renderVisibleRows();
  afterRender?.();
}
